// @flow

import type { FirstCareIndexState } from "./types";

export const setLoading = (state: FirstCareIndexState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onCreateAbsenceTrendsReportSuccess = (state: FirstCareIndexState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    error: null,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    absenceTrendsReport: payload,
  };
};

export const onAbsenceTrendsReportError = (state: FirstCareIndexState) => ({ payload }: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};
